import React,{useState,useEffect,useRef} from 'react'
import axios from 'axios'
import { API_URL } from '../../Constant';
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../assets/Messages.json'
import { useNavigate } from 'react-router-dom';
import {showAppLoading, generateYearRange,isNumeric, validateButtonASIBlock,getStatusFlagValue} from '../../Custom/Custom';
import asiTitle from '../../asi.json';

export default function BlockD({
  blockPageInfo,
  config,
  userInfoObject,
  blockInfo,
  accessAsiBlock,
  decode_token
}) {

   
   const [itemData, setItemData] = useState({});
   const [blockDData, setBlockDData] = useState({});
   const navigate = useNavigate();
   const yearRange=generateYearRange(blockInfo.surveyYear);
   let srNo=0;
   const boldTexId=[4,7,11,15,16]
  const [buttonStatus,setButtonStatus]=useState('');
  const roleCodes = decode_token?.id?.ROLE_CODE
    ? String(decode_token.id.ROLE_CODE)
        .split('|')
        .map((r) => String(r).trim())
        .filter(Boolean)
    : [];
  const isDivasiRole = roleCodes.includes('DIVASI');
  const isHqRole = roleCodes.includes('HQADM') || roleCodes.includes('HQASI');
  const currentStatusFlag = Array.isArray(blockDData) && blockDData.length > 0 ? blockDData[0]?.statusFlag : '';
  const isDivasiStatusFlagOne = isDivasiRole && String(currentStatusFlag ?? '').trim() === '1';
  const isHqStatusFlagThree = isHqRole && String(currentStatusFlag ?? '').trim() === '3';
  const isRestrictedRoleWithEmptyStatusFlag = (isDivasiRole || isHqRole) && String(currentStatusFlag ?? '').trim() === '';
  const isNextBlockAlreadyAccessible = (() => {
    const ids = JSON.parse(localStorage.getItem('blockIds') || '[]');
    return Array.isArray(ids) && ids.map(Number).includes(5);
  })();
  const statusUnitCode=localStorage.getItem('statusUnitCode')

  // Ref to prevent multiple API calls
  const apiCallMadeRef = useRef(false);
  const isLoadingRef = useRef(false);

  

   useEffect(()=>{
  
    // Prevent multiple API calls
    if (apiCallMadeRef.current || isLoadingRef.current || !blockInfo.dslNo || !blockInfo.surveyYear) {
      return;
    }

    apiCallMadeRef.current = true;
    isLoadingRef.current = true;

    // Function to handle page load Form data
      const blockDData= async()=>{
      const newObject={
         dsl_no: blockInfo.dslNo,
         survey_year: blockInfo.surveyYear
       };
       showAppLoading(true)
       try {
         const response = await axios.post(`${API_URL}api/asi/blockDForm`, newObject, config);
         const {data,status} = response.data;
            if (status) {
               const blockDData=data.blockDData;
               setBlockDData(blockDData)
               const statusFlage = blockDData[0].statusFlag;
               const buttonStatus = await validateButtonASIBlock(decode_token, statusFlage);
              setButtonStatus(buttonStatus);
              const initialData = {};
               blockDData.forEach(item => {
                    initialData[item.itemCode] = {
                     dslNo: item.dslNo,
                     surveyYear: item.surveyYear,
                     itemCode: item.itemCode,
                     openingAmount: item.openingAmount,
                     closingAmount: item.closingAmount,
                     statusFlag: item.statusFlag,
                     itemName: item.itemName,
                     openingAmountClass:'textBox_back_color_white',
                     closingAmountClass:'textBox_back_color_white'
                    };
                  });
               
              setItemData(initialData);
            }
       } catch (error) {
           console.error(error);
           toast.error('An error occurred while processing your request.', messages.COLOR_RED);
           apiCallMadeRef.current = false; // Reset on error to allow retry
       } finally {
           showAppLoading(false);
           isLoadingRef.current = false;
       }
   
     }
     blockDData();
   
     },[blockInfo.dslNo, blockInfo.surveyYear, config, decode_token])

 // Function to handle State on change    
  const handleOnChange = (assetCode, field, newValue) => {  
      
    // Allow empty string, negative sign, or valid numeric values (including negative)
    if (newValue === '' || newValue === '-') {
      // Allow empty or just negative sign (user is typing)
      setItemData(prevItemData => {
        const updatedItemData = {
          ...prevItemData,
          [assetCode]: {
          ...prevItemData[assetCode],
          [field]: newValue
          }
        };
        return updatedItemData;
      });
      return;
    }

    // Check if it's a valid number (including negative)
    // Allow: empty, negative sign, digits, decimal point
    const numericRegex = /^-?\d*\.?\d*$/;
    if (!numericRegex.test(newValue)) {
      toast.error(messages.NUMERIC_MSG, messages.COLOR_RED);
      return; // Don't update if invalid
    }

    setItemData(prevItemData => {
      const updatedItemData = {
        ...prevItemData,
        [assetCode]: {
        ...prevItemData[assetCode],
        [field]: newValue
        }
      };

      return updatedItemData;
      });
  }

  // Function to handle going to the next block   
   
  const handleNext= async()=>{
    // Next unlocked + Save disabled → skip save, sirf navigate (DIVASI/FACTO/DISASI/HQ sab)
    if (isNextBlockAlreadyAccessible && (buttonStatus || isDivasiStatusFlagOne || isHqStatusFlagThree || isRestrictedRoleWithEmptyStatusFlag)) {
      navigate("/BlockE");
      return;
    }
    // DIVASI + statusFlag=1: do not save, just navigate
    if (isDivasiStatusFlagOne) {
      navigate("/BlockE");
      return;
    }
    // HQADM/HQASI + statusFlag=3: do not save, just navigate
    if (isHqStatusFlagThree) {
      navigate("/BlockE");
      return;
    }
    const confirmed = window.confirm("Have you saved your changes?");
    if (!confirmed) return;
    if(statusUnitCode==='5'){
        const saveResult = await handleSaveData("SAVE");
        if(saveResult){
          blockValidation()
          navigate("/BlockE")
        }
    }else{
      const saveResult = await handleSaveData("SAVE");
      if (saveResult) {
        blockValidation()
        navigate("/BlockE")
      }
    }
    
}




  //All block validation Data
  const  blockValidation=async()=>{

    let  postData= {
       dsl_no: blockInfo.dslNo,
       survey_year: blockInfo.surveyYear
      }
  
   try {
       showAppLoading(true);
       const response = await axios.post(`${API_URL}api/asi/blockValidation`, postData, config);
       const {data,status} = response.data;
       const accessIds=data.allblockData
      
        if(accessIds.length>0){
            if(accessIds.length > [1,2,3,4,5].length){
              accessAsiBlock(accessIds)
            }else{
              accessAsiBlock([1,2,3,4,5])
            }
        }else{
          accessAsiBlock([1,2,3,4,5])
        }
        showAppLoading(false);
         return true;
  
       } catch (error) {
          console.error(error);
          toast.error('An error occurred while processing your request.', messages.COLOR_RED);
      } finally {
      
     }
  
  }
 

// Function to handle going to the previous block
const handlePrevious=()=>{
  const confirmed = window.confirm("Have you saved your changes?");
  if (confirmed) {
      // handleSaveData("SAVE");
      navigate("/BlockC");
    }
}

// Function to handle reset Form Data
const handleReset=()=>{
   const initialData = {};
   blockDData.forEach(item => {
        initialData[item.itemCode] = {
          dslNo: item.dslNo,
          surveyYear: item.surveyYear,
          itemCode: item.itemCode,
          statusFlag: item.statusFlag,
          itemName: item.itemName,
          openingAmount: '',
          closingAmount: '',
         openingAmountClass:'textBox_back_color_white',
         closingAmountClass:'textBox_back_color_white'
        };
      });
   
  setItemData(initialData);
  

}

// Function to handle update and save form data
const handleSaveData = async(buttonType) => {

      if (statusUnitCode !== '5' && !valForBlockD()) {
        return false;
      }
   
    let customItemCodes=[];
    const clickButtonStatusFlag = getStatusFlagValue(buttonType, userInfoObject.userLevel);
const allItemData=itemData;
 for (let itemId in allItemData) {
       const customObject = {
        dslNo: itemData[itemId].dslNo,
        surveyYear: itemData[itemId].surveyYear,
        itemCode: itemData[itemId].itemCode,
        statusFlag: clickButtonStatusFlag,
        openingAmount:handleValue(itemData[itemId].openingAmount),
        closingAmount:handleValue(itemData[itemId].closingAmount),
        // createdBy:'',
        // createdTime:''
     };
       customItemCodes.push(customObject); 
  }
    const newObject={
      itemCodes:customItemCodes,
      payload:{
        dsl_no: blockInfo.dslNo,
        survey_year:  blockInfo.surveyYear,
        buttonType:buttonType
      }
    }
  
    showAppLoading(true);
   try {
      const response = await axios.post(`${API_URL}api/asi/blockDFormSaveToDB`, newObject, config);
      const {status,message} = response.data;
      if (status) {
        blockValidation();
        toast.success(message, messages.COLOR_RED);
        return true;
      }
    } catch (error) {
        console.error(error);
        toast.error('An error occurred while processing your request.', messages.COLOR_RED);
    } finally {
        showAppLoading(false);
    }
  

 return false;
 

}

// Function to handle if value empty or null or undefined the set 0
const handleValue = (value) => {
  return (value !== "" && value !== null && value !== undefined) ? value : 0;
};


// Function to handle calculation of form data
const valForBlockD=()=>{
  let allValidaction="";
  let customItemCodes=[];
  let statusAlertD=0;
  let openingAmountAll=[];
  let closingAmountAll=[];
  let openingSubTotal13calc=0;
  let openingSubTotal13=0;
  let closingsubtotal13calc=0;
  let closingsubtotal13=0;
  let flagD=0;
  let yearArray = [2017,2018,2019,2020,2021];
  // if(yearArray.includes(blockInfo.surveyYear)){
   
         for (let itemId in itemData) {
              if(yearArray.includes(blockInfo.surveyYear)){
                if(itemId !== '24'  || itemId !== '27' || itemId !== '31' || itemId !== '37' ){
                                        
                  const { openingAmount: openingAmountRs = 0, closingAmount: closingAmountRs = 0 } = itemData[itemId] ?? {}; 
                  const safeOpeningRs = openingAmountRs === '' ? 0 : openingAmountRs;
                  const safeClosingRs = closingAmountRs === '' ? 0 : closingAmountRs;


                    if(parseFloat(safeOpeningRs) > 0 &&  parseFloat(safeClosingRs) > 0){
                        let  ratio= parseFloat(safeOpeningRs/safeClosingRs);
                        if(0.2 <= parseFloat(ratio) &&  parseFloat(ratio)<=5){
                          itemData[itemId].openingAmountClass="textBox_back_color_white";
                          itemData[itemId].closingAmountClass="textBox_back_color_white";
                      }else{
                        itemData[itemId].openingAmountClass="textBox_back_color_orange";
                        itemData[itemId].closingAmountClass="textBox_back_color_orange";
              
                          if(allValidaction.indexOf("If col. 3 and col. 4 >0, then 0.2 <")<0){
                              allValidaction= " If col. 3 and col. 4 >0, then 0.2 < = col. 3 /col. 4 < = 5 \n"
                          }
                          statusAlertD=1;
                      }
                    }
                
                }
                if(itemId  === '31' ){//Total current assets (7 to 10)
              
                    const { openingAmount: openingRs11 = 0, closingAmount: closingRs11 = 0 } = itemData[31] ?? {}; // Total current assets (7 to 10)
                    const { openingAmount: openingRs15 = 0, closingAmount: closingRs15 = 0 } = itemData[35] ?? {}; // Total current liabilities (12 to 14)
                    const safeOpeningRs11 = openingRs11 === '' ? 0 : openingRs11;
                    const safeClosingRs11 = closingRs11 === '' ? 0 : closingRs11;
                    const safeOpeningRs15 = openingRs15 === '' ? 0 : openingRs15;
                    const safeClosingRs15 = closingRs15 === '' ? 0 : closingRs15;

                    if(parseFloat(safeOpeningRs11) > 0 &&  parseFloat(safeOpeningRs15) > 0){ 
                      let ratioCol3 = parseFloat(safeOpeningRs11)/parseFloat(safeOpeningRs15);
                      if(0.2 <= parseFloat(ratioCol3) &&  parseFloat(ratioCol3)<=5){
                      itemData[31].openingAmountClass="textBox_back_color_white";
                      itemData[35].openingAmountClass="textBox_back_color_white";
                        
                    }else{
                        itemData[31].openingAmountClass="textBox_back_color_orange";
                        itemData[35].openingAmountClass="textBox_back_color_orange"

                        if(allValidaction.indexOf("0.2<=(Item11 Col 3/Item15 Col 3)<=5 <")<0){
                            allValidaction= " 0.2<=(Item11 Col 3/Item15 Col 3)<=5 \n"
                        }
                        statusAlertD=1;
                    }

                    }


                    if(parseFloat(safeClosingRs11) > 0 &&  parseFloat(safeClosingRs15) > 0){ 
                        let ratioCol4 = parseFloat(safeClosingRs11)/parseFloat(safeClosingRs15);
                    if(0.2 <= parseFloat(ratioCol4) &&  parseFloat(ratioCol4)<=5){
                        itemData[31].closingAmountClass="textBox_back_color_white";
                        itemData[35].closingAmountClass="textBox_back_color_white";
                    }else{
                      itemData[31].closingAmountClass="textBox_back_color_orange";
                      itemData[35].closingAmountClass="textBox_back_color_orange";
                        if(allValidaction.indexOf("0.2<=(Item11 Col 4/Item15 Col 4)<=5")<0){
                            allValidaction= " 0.2<=(Item11 Col 4/Item15 Col 4)<=5 \n"
                        }
                        statusAlertD=1;
                    }
                    }
              


                }
              }
            const customObject = {
             itemCode: itemData[itemId].itemCode,
             openingAmount: handleValue(itemData[itemId].openingAmount),
             closingAmount: handleValue(itemData[itemId].closingAmount),
             statusFlag: itemData[itemId].statusFlag,
             itemName: itemData[itemId].itemName,
             openingAmountClass:itemData[itemId].openingAmountClass,
             closingAmountClass:itemData[itemId].closingAmountClass,
          };
          customItemCodes.push(customObject); 
          openingAmountAll.push(handleValue(customObject.openingAmount))
          closingAmountAll.push(handleValue(customObject.closingAmount))
      }
        /*************************OLD formulas *************************************************/

//Opening****************
         openingSubTotal13calc=parseFloat(parseFloat(openingAmountAll[0])+
          parseFloat(openingAmountAll[1])+parseFloat(openingAmountAll[2])); 
          openingSubTotal13=parseFloat(openingAmountAll[3]);
         if(openingSubTotal13calc !== openingSubTotal13){
            customItemCodes[3].openingAmountClass="textBox_back_color_red"
            flagD=1;
        }else{
           customItemCodes[3].openingAmountClass="textBox_back_color_white";
        }
      
 ///Closing****************
          closingsubtotal13calc=parseFloat(parseFloat(closingAmountAll[0])+
          parseFloat(closingAmountAll[1])+parseFloat(closingAmountAll[2]));
          closingsubtotal13 = parseFloat(closingAmountAll[3]);
          if(closingsubtotal13calc !== closingsubtotal13) {
            customItemCodes[3].closingAmountClass="textBox_back_color_red"
          }
          else{
            customItemCodes[3].closingAmountClass="textBox_back_color_white"
          }

// #Opening and closing 4 to 5 and 6 index (Start index =0)

          const tinvencalcopening=parseFloat(parseFloat(openingAmountAll[4])+
          parseFloat(openingAmountAll[5])+parseFloat(openingSubTotal13));
          const tinvencalcclosing=parseFloat(parseFloat(closingAmountAll[4])+
          parseFloat(closingAmountAll[5])+parseFloat(closingsubtotal13));
          const totalinvenoryopening= parseFloat(openingAmountAll[6])
          const totalinvenoryclosing=parseFloat(closingAmountAll[6])

          if(totalinvenoryopening!==tinvencalcopening){
              customItemCodes[6].openingAmountClass="textBox_back_color_red"
                flagD=1;
          }else{
            customItemCodes[6].openingAmountClass="textBox_back_color_white"
          }


          if(totalinvenoryclosing!==tinvencalcclosing){
            customItemCodes[6].closingAmountClass="textBox_back_color_red"
            flagD=1;
          }else{
            customItemCodes[6].closingAmountClass="textBox_back_color_white"
          }


 //#Opening and closing 7 to 9 and 10 index (Start index =0) 
          const totalcurrassetscalcopening=parseFloat(parseFloat(totalinvenoryopening)+parseFloat(openingAmountAll[7])+
          parseFloat(openingAmountAll[8])+parseFloat(openingAmountAll[9]));
         const totalcurrassetscalcClosing=parseFloat(parseFloat(totalinvenoryclosing)+parseFloat(closingAmountAll[7])+
          parseFloat(closingAmountAll[8])+parseFloat(closingAmountAll[9]));
          const totalcAssetsopening=parseFloat(openingAmountAll[10])
          const totalcAssetsclosing=parseFloat(closingAmountAll[10]);

           if(totalcAssetsopening !== totalcurrassetscalcopening) {
              customItemCodes[10].openingAmountClass="textBox_back_color_red";
           }else{
               customItemCodes[10].openingAmountClass="textBox_back_color_white";
           }  

           if(totalcAssetsclosing !== totalcurrassetscalcClosing){
            customItemCodes[10].closingAmountClass="textBox_back_color_red";
           }else{
            customItemCodes[10].closingAmountClass="textBox_back_color_white";
           } 
          
 //#Opening and closing 11 to 13 and 14 index (Start index =0) --working
      const totalcurrliabilitescalcopening=parseFloat(parseFloat(openingAmountAll[11])+
        parseFloat(openingAmountAll[12])+parseFloat(openingAmountAll[13]));
      const totalcurrliabilitescalcclosing=parseFloat(parseFloat(closingAmountAll[11])+
        parseFloat(closingAmountAll[12])+parseFloat(closingAmountAll[13]));
        const totalcurrliabilitiesopening= parseFloat(openingAmountAll[14]);
        const totalcurrliabilitiesclosing=parseFloat(closingAmountAll[14]);

      if(totalcurrliabilitiesopening!==totalcurrliabilitescalcopening) {
          customItemCodes[14].openingAmountClass="textBox_back_color_red";
        }else{
          customItemCodes[14].openingAmountClass="textBox_back_color_white";
        }
        if(totalcurrliabilitiesclosing!==totalcurrliabilitescalcclosing){
            customItemCodes[14].closingAmountClass="textBox_back_color_red";
            flagD=1;
        }else{
          customItemCodes[14].closingAmountClass="textBox_back_color_white";
        }

    
 //#Opening and closing 15 index (Start index =0)

      const workingcapitalopening=parseFloat(openingAmountAll[15]);
      const workingcapitalclosing=parseFloat(closingAmountAll[15])
      const diffopening=parseFloat(parseFloat(totalcAssetsopening)-parseFloat(totalcurrliabilitiesopening));
      const diffclosing=parseFloat(parseFloat(totalcAssetsclosing)-parseFloat(totalcurrliabilitiesclosing));
      if(workingcapitalopening !== diffopening){
          customItemCodes[15].openingAmountClass="textBox_back_color_red";
            flagD=1;
      }else{
          customItemCodes[15].openingAmountClass="textBox_back_color_white";
      }
      
      if(workingcapitalclosing !== diffclosing){
          customItemCodes[15].closingAmountClass="textBox_back_color_red";
      }else{
          customItemCodes[15].closingAmountClass="textBox_back_color_white";
      }
    
      handleValidationAlert(customItemCodes) // state Update**************
      
        if (statusAlertD === 1 &&  (yearArray.includes(blockInfo.surveyYear))) {
        
          allValidaction = allValidaction+" \nFor change any Values Click OK."
          var clicked = window.confirm(allValidaction);                    
          allValidaction="";
          statusAlertD = 0;
          if(clicked){
              // valifla = "notnull";
              return false;
          }
          
      }


      if(flagD===1)
      { 
          // alert('Total not matched, Please check Highlight Fields');
          toast.error('Total not matched, Please check Highlight Fields.', messages.COLOR_RED);
          flagD=0;
          return false;
      }
        return true

 //}

// }

 
}

// Function to handle set (Update State) form validation and calculation 
const handleValidationAlert = (customItemCodes) => { 
  const initialData = {};
  customItemCodes.forEach(item => {
         initialData[item.itemCode] = {
        itemCode: item.itemCode,
        openingAmount: item.openingAmount,
        closingAmount: item.closingAmount,
        statusFlag: item.statusFlag,
        itemName: item.itemName,
        openingAmountClass:item.openingAmountClass,
        closingAmountClass:item.closingAmountClass,
 
       };
     });
  
 setItemData(initialData);
}

const storedLanguage = localStorage.getItem('language');

  return (
    <div className="card-body">
    {/* <ToastContainer/> */}
         <h4 className="page_heading border-bottom-0">
         <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.BLOCK_D_TITLE : asiTitle.en.BLOCK_D_TITLE }} />
        </h4>

          <div className="row">
               <div className="col-12">
               <h6 className="fw-semibold">
                     {storedLanguage === 'hi' ? asiTitle.hi.DSL_NO : asiTitle.en.DSL_NO}: <span className="fw-normal me-5">{blockInfo.dslNo}</span> 
                     {storedLanguage === 'hi' ? asiTitle.hi.SERVEY_YEAR : asiTitle.en.SERVEY_YEAR}: <span className="fw-normal">{yearRange}</span>
                    </h6>
                <div className="table-responsive asi_block_table">
                     <table cellPadding="0" cellSpacing="0"  className="table table-bordered block_c_table">
                            <thead>
                               <tr>
                                  <th>{storedLanguage === 'hi' ? asiTitle.hi.SL_NO : asiTitle.en.SL_NO}</th>
                                  <th>{storedLanguage === 'hi' ? asiTitle.hi.ITEMS : asiTitle.en.ITEMS}</th>
                                  <th>{storedLanguage === 'hi' ? asiTitle.hi.OPENING_RS : asiTitle.en.OPENING_RS}</th>
                                  <th>{storedLanguage === 'hi' ? asiTitle.hi.CLOSING_RS : asiTitle.en.CLOSING_RS}</th>
                               </tr>
                               <tr>
                                  <th>1</th>
                                  <th>2</th>
                                  <th>3</th>
                                  <th>4</th>
                               </tr>
                               </thead>
                               <tbody>
                               {blockDData.length >0 && blockDData.map((item,i)=>{

                                return <tr key={i}>
                                <td valign="top"> 
                                 {++srNo}
                                </td>
                                <td>
                                
                                 {
                                 boldTexId.includes(srNo) ? <b>{item.itemName}</b> : item.itemName
                                 }
                               
                                </td>
                                <td className={itemData[item.itemCode].openingAmountClass}>
                                   <input 
                                    type="text" 
                                    className="form-control"
                                    maxLength="19"
                                    id={`openingAmount${i}`}
                                    name={`openingAmount${i}`}
                                    value={`${itemData[item.itemCode].openingAmount}`}
                                    onChange={e => handleOnChange(item.itemCode, 'openingAmount', e.target.value)}
                                   /> 
                                </td>
                                <td className={itemData[item.itemCode].closingAmountClass}>
                                   <input 
                                   type="text" 
                                  className="form-control"
                                   maxLength="19"
                                   id={`closingAmount${i}`}
                                   name={`closingAmount${i}`}
                                   value={`${itemData[item.itemCode].closingAmount}`}
                                   onChange={e => handleOnChange(item.itemCode, 'closingAmount', e.target.value)}
                                   /> 
                                </td>
                             </tr>
                               })}

                               
                               
                            </tbody>
                    </table>
                  </div>
               </div>
             
            </div>

            <div className="row">
                <div className="col-12">
                  <hr/>
                </div>
            
                <div className="col-lg-8 text-center text-lg-start mb-3 mb-lg-0">
                      <button 
                      type="submit" 
                      className="btn btn_orange me-1"
                      onClick={()=>{ window.print()}}
                      >Print 
                      <i className="fa fa-print ms-1"></i>
                      </button>

                      <button 
                      type="button" 
                      className="btn btn_orange me-1"
                      onClick={(e)=>{handleSaveData("SAVE")}}
                      disabled={buttonStatus || isDivasiStatusFlagOne || isHqStatusFlagThree || isRestrictedRoleWithEmptyStatusFlag}>
                      Save
                     </button>

                      <button 
                      type="reset" 
                      className="btn btn_orange me-1"
                      onClick={handleReset}
                      >
                      Reset
                     </button>

                      <button 
                      type="button" 
                      className="btn btn_orange"
                      onClick={(e)=>( navigate("/dashboard"))}
                      >
                      Cancel
                    </button>

                </div>
              
                <div className="col-lg-4 text-center text-lg-end">
                  <button 
                  type="button" 
                  className="btn btn_orange mx-1"
                  onClick={handlePrevious}
                  >
                  <i className="fa fa-angle-left me-1"></i> 
                  Previous
                 </button>

                  <button 
                  type="button" 
                  className="btn btn_orange mx-1"
                  onClick={handleNext}
                  disabled={isNextBlockAlreadyAccessible ? false : (isRestrictedRoleWithEmptyStatusFlag ? true : ((isDivasiStatusFlagOne || isHqStatusFlagThree) ? false : buttonStatus))}
                  >
                  Next
                  <i className="fa fa-angle-right ms-1"></i>
                </button>

                </div>
                        
            </div>
          </div>

)
}

